import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import {
  Global,
  LineSelectedSchedule,
  LineSelectedTask
} from '../model';
import PlannerControllerBase from './base';
import { NewValuesFormsTasksUpdate } from './new_values/forms_tasks_update';
export default class ResponseController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.listenResponseThen();
  }
  listenResponseThen(){
    this.reduxEvent('data.response_then', (newVal, oldVal, objectPath) => {
      this.onResponse(newVal, oldVal, objectPath);
    });
  }
  // サーバーからのレスポンス
  onResponse(newVal, oldVal, projectPath){
    if(newVal == null){ return; }
    if(newVal.method == 'on_create_schedule') {
      this.onCreateSchedule(newVal.options);
    } else if (newVal.method == 'on_update_schedule') {
      this.onUpdateSchedule(newVal.options);
    } else if (newVal.method == 'on_update_task') {
      this.onUpdateTask(newVal.options);
    } else if (newVal.method == 'on_create_or_update_memo') {
      this.onCreateOrUpdateTasksMemo(newVal.options);
    } else if (newVal.method == 'on_destroy_schedule') {
      this.onDestloySchedule(newVal.options);
    } else if (newVal.method == 'on_create_line') {
      this.onCreateLine(newVal.options);
    } else if (newVal.method == 'on_destroy_line') {
      this.onDestroyLine(newVal.options);
    }
  }
  // スケジュールが作成された
  onCreateSchedule(options){
    let scheduleId = options.schedule_id;
    let lineId = options.line_id;
    let schedule: LineSelectedSchedule = new LineSelectedSchedule(scheduleId, lineId);
    let newVal = {}
    NewValuesFormsTasksUpdate.set(newVal, schedule);
    this.updateData(newVal)
    this.updatePlanner({
      orders_planner: {
        selectedCell: null,
        createSchedule: null,
        selectedSchedule: schedule,
        selectedTask: schedule.task(),
      }
    });
  }
  // スケジュールが更新された
  onUpdateSchedule(options){
    let destroyed_memos = options.destroyed_memos
    for(let i=0;i<destroyed_memos.length;i++){
      let composite_id = destroyed_memos[0]
      let scope = Global.dataScopeTasksMemo(composite_id)
      let newValue = {};
      newValue[scope] = null;
      this.updateMemos(newValue)
    }
  }
  // タスクが更新された
  onUpdateTask(options){
    // nothing to do
  }
  // メモが更新もしくは作成された
  onCreateOrUpdateTasksMemo(options){
    this.updatePlanner({
      orders_planner: {
        selectedTasksMemo: null
      }
    });
  }
  // スケジュールが削除された
  onDestloySchedule(options){
    this.updateData({
      command: {
        updated_at: new Date().getTime(),
        options: options.notifyOptions,
        command: options.command
      }
    })
  }
  // ラインが作成された
  onCreateLine(options){
    // nothing to do
  }
  // ラインが削除された
  onDestroyLine(options){
    // nothing to do
  }
}
